import * as React from 'react';
import Report from '../powerBIComponents/Report';
import { connect } from 'react-redux'
import * as PBAction from '../../store/actions/powerBIActions'
import { ReportVisual } from '../powerBIComponents/ReportVisual';
import { LocalizationTest } from './LocalizationTest'
import { InputText } from 'primereact/inputtext'
import { Tree } from 'primereact/tree';
import * as SA from '../../store/actions/applicationSettingsActions'

import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'bootstrap/dist/css/bootstrap.css';
import { Dashboard } from '../powerBIComponents/Dashboard'


class PowerBIFNTDashboard extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            embedConfig: {
                settings: {}
            }
        };
    }


    componentDidMount() {
        this.props.loadApplicationSettings();
    }

    componentDidUpdate(prevProps) {

        if (prevProps.webapiUrl != this.props.webapiUrl) {
            if (this.props.webapiUrl != null) {
                this.props.getFNTUserToken(this.props.webapiUrl);
                this.props.getFNTDashboards(this.props.webapiUrl);
            }
        }

        if (prevProps.fntUserToken != this.props.fntUserToken) {
            if (this.props.fntDashboards != null && this.props.fntUserToken != null) {
                this.changeEmbedConfig(this.props.fntDashboards[0], this.props.fntUserToken);
            }
        }

        if (prevProps.fntDashboards != this.props.fntDashboards) {
            if (this.props.fntDashboards != null && this.props.fntUserToken != null) {
                this.changeEmbedConfig(this.props.fntDashboards[0], this.props.fntUserToken);
            }
        }

    }

    onEmbedded(embed) {
        /**
         * Commenting out because it's unnecessary
         * - Mason Smith 
         */
        // console.log(`Report embedded: `, embed, this);
    }

    changeEmbedConfig(fntDashboard, userToken) {
        var embedConfig = this.state.embedConfig;
        embedConfig.id = fntDashboard.id;
        embedConfig.embedUrl = fntDashboard.embedUrl;
        embedConfig.accessToken = userToken;

        embedConfig.settings = {
            filterPaneEnabled: embedConfig.settings.filterPaneEnabled,
            navContentPaneEnabled: embedConfig.settings.navContentPaneEnabled
        };

        this.setState({ embedConfig, reportVisual: false, localization: false });
    }

    render() {
        return (
            <div className='row'>
                <div className='col-md-12'>
                    <Dashboard
                        accessToken={this.state.embedConfig.accessToken}
                        id={this.state.embedConfig.id}
                        embedUrl={this.state.embedConfig.embedUrl}
                        filterPaneEnabled={this.state.embedConfig.settings.filterPaneEnabled}
                        navContentPaneEnabled={this.state.embedConfig.settings.navContentPaneEnabled}
                        onEmbedded={this.onEmbedded}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        webapiUrl: state.applicationSettingsReducer.webapiUrl,
        fntUserToken: state.powerBIReducer.fntUserToken,
        fntDashboards: state.powerBIReducer.fntDashboards
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getFNTDashboards: (webapiUrl) => dispatch(PBAction.getFNTDashboards(webapiUrl)),
        loadApplicationSettings: () => dispatch(SA.loadApplicationSettings()),
        getFNTUserToken: (webapiUrl) => dispatch(PBAction.getFNTToken(webapiUrl))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PowerBIFNTDashboard);



// WEBPACK FOOTER //
// ./src/components/i4Reports/PowerBIFNTDashboard.tsx